import { render, staticRenderFns } from "./settlementIncome.vue?vue&type=template&id=09d2aefd&scoped=true&"
import script from "./settlementIncome.vue?vue&type=script&lang=js&"
export * from "./settlementIncome.vue?vue&type=script&lang=js&"
import style0 from "./settlementIncome.vue?vue&type=style&index=0&id=09d2aefd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d2aefd",
  null
  
)

export default component.exports